import React, { useEffect, useMemo } from 'react';

import { routes } from '../../routes';
import { PremiumSermonService } from '../../services/PremiumSermonService';
import { PremiumSermonSeriesService } from '../../services/PremiumSermonSeriesService';
import { LoadingPage } from '../../components/LoadingPage';
import { useUser } from '../../utilities/useUser';
import { BuilderAssetService, SaveBuilderAssetRequest } from '../../services/BuilderAssetService';
import { EventTracking } from '../../utilities/Tracking/EventTracking';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '../../components/useQueryParams';
import { SubscriptionService } from '../../services/SubscriptionService';

const params = new URLSearchParams(localStorage.getItem("registerParams") ?? "")

export function ConfirmationPage(){
    const routeQueryString = useQueryParams();
    const userContext = useUser();
    const history = useHistory();
    
    const redirect = useMemo(() => params.get("redirect") ?? routes.app.libraryHomePage, [params])
    const premiumSeriesId = useMemo(() => params.get("premiumSeriesId"), [params]);
    const premiumSermonId = useMemo(() => params.get("premiumSermonId"), [params]);
    const builderPreviewId = useMemo(() => params.get("builderPreviewId"), [params]);

    useEffect(() => {
        async function handleConfirmation(){
            const sessionId = routeQueryString.get("sessionId")

            if(!sessionId) return history.push(routes.app.activatePage);

            const userResponse = await SubscriptionService.recordCheckout(sessionId)

            if(userResponse.error) return;
            if(userResponse.success){              
                if (premiumSeriesId) {
                    await PremiumSermonSeriesService.purchase(parseInt(premiumSeriesId));
                    const containerId = await PremiumSermonSeriesService.activate(parseInt(premiumSeriesId));

                    if(containerId.success){
                        userContext.updateUser(userResponse.data);               
                        return history.push(routes.app.resolve.libraryFolder(containerId.data))
                    }
                }
                
                if(premiumSermonId) {
                    await PremiumSermonService.purchase(parseInt(premiumSermonId));
                    const containerId = await PremiumSermonService.activate(parseInt(premiumSermonId));

                    if(containerId.success){
                        userContext.updateUser(userResponse.data);               
                        return history.push(routes.app.resolve.libraryFolder(containerId.data))
                    }
                }

                if(builderPreviewId){
                    const sermonAssetResponse = await BuilderAssetService.getSermonAsBuilderAsset(builderPreviewId);
                    if(sermonAssetResponse.success){
                        const saveAssetRequest:SaveBuilderAssetRequest = {
                            ...sermonAssetResponse.data,
                            id: undefined,
                        } 
                        const response = await BuilderAssetService.save(saveAssetRequest);
                        EventTracking.Builder.onImportSCSermon(Number(builderPreviewId));
                        
                        if(response.success){
                            userContext.updateUser(userResponse.data);               
                            return history.push(routes.app.resolve.builderPage(response.data.id))
                        }
                    }
                }   

                userContext.updateUser(userResponse.data);  
                return history.push(redirect)    
            }
        }
    
        handleConfirmation()
    }, [])

    return <LoadingPage />
}